"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resumeConnectTransfer = exports.remoteTransfer = exports.pushToUploadPage = exports.httpUpload = exports.httpGatewayUpload = exports.httpGatewayDownload = exports.httpDownload = exports.getRemoteFiles = exports.getAllConnectTransfers = exports.forwardPackage = exports.dismissAsperaVersionBanner = exports.dismissAsperaInstall = exports.connectUpload = exports.connectDownload = exports.updateTransfer = exports.storeTransfer = exports.showAsperaVersionBanner = exports.showAsperaInstall = exports.setHttpGatewayStatus = exports.setConnectVersion = exports.selectFiles = exports.retryHttpUploadRequest = exports.removeFile = exports.remoteTransferSuccess = exports.remoteTransferRequest = exports.remoteTransferReject = exports.pluginEvent = exports.httpUploadSuccess = exports.httpUploadRequest = exports.httpUploadReject = exports.hideAsperaVersionBanner = exports.hideAsperaInstall = exports.getRemoteFilesSuccess = exports.getRemoteFilesRequest = exports.gatewayTransferStarted = exports.gatewayTransferReject = exports.gatewayTransferFailed = exports.gatewayTransferCompleted = exports.forwardPackageSuccess = exports.forwardPackageRequest = exports.forwardPackageReject = exports.downloadReject = exports.connectUploadSuccess = exports.connectUploadRequest = exports.connectUploadReject = exports.connectTransferStarted = exports.connectTransferReject = exports.connectTransferCompleted = exports.connectDownloadRequest = exports.clearStagedFiles = void 0;
exports.stopConnectTransfer = exports.stopAspera = exports.startAspera = exports.showTransferManager = exports.showPreferences = exports.showDirectory = exports.showAsperaVersionBannerActionCreator = exports.showAsperaInstallActionCreator = exports.retryHttpUpload = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* Package Imports */
var connected_react_router_1 = require("connected-react-router");
var moment_1 = __importDefault(require("moment"));
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var eventManager_1 = require("../eventManager");
var pluginActions_1 = require("../pluginActions");
var models_1 = require("@app/_state/models");
var actions_1 = require("@app/features/new-packages/state/actions");
var actions_2 = require("@app/features/ui/state/actions");
var actions_3 = require("@app/features/users/state/actions");
var PackagesApi = __importStar(require("@app/services/api/packages"));
var TransfersApi = __importStar(require("@app/services/api/transfers"));
var config_1 = require("@app/shared/config");
var constants_1 = require("@app/shared/constants");
var matomo_1 = require("@app/shared/matomo");
var api_1 = require("@server/types/api");
var createAction = typesafe_actions_1.deprecated.createAction;
/* Action Creators - begin */
exports.clearStagedFiles = createAction('@@transfers/CLEAR_STAGED_FILES');
exports.connectDownloadRequest = createAction('@@transfers/CONNECT_DOWNLOAD_REQUEST', function (resolve) { return function (packageId, filePath) { return resolve({ packageId: packageId, filePath: filePath }); }; });
exports.connectTransferCompleted = createAction('@@transfers/CONNECT_TRANSFER_COMPLETED', function (resolve) { return function (requestId, direction) { return resolve({ requestId: requestId, direction: direction }); }; });
exports.connectTransferReject = createAction('@@transfers/CONNECT_TRANSFER_REJECT', function (resolve) { return function (requestId, packageId, filePath) { return resolve({ requestId: requestId, packageId: packageId, filePath: filePath }); }; });
exports.connectTransferStarted = createAction('@@transfers/CONNECT_TRANSFER_STARTED', function (resolve) { return function (requestId, packageId, direction, title) { return resolve({ requestId: requestId, packageId: packageId, direction: direction, title: title }); }; });
exports.connectUploadReject = createAction('@@transfers/CONNECT_UPLOAD_REJECT');
exports.connectUploadRequest = createAction('@@transfers/CONNECT_UPLOAD_REQUEST');
exports.connectUploadSuccess = createAction('@@transfers/CONNECT_UPLOAD_SUCCESS');
exports.downloadReject = createAction('@@transfers/DOWNLOAD_REJECT', function (resolve) { return function (packageId, filePath) { return resolve({ packageId: packageId, filePath: filePath }); }; });
exports.forwardPackageReject = createAction('@@transfers/FORWARD_PACKAGE_REJECT', function (resolve) { return function (error, request) { return resolve({ error: error, request: request }); }; });
exports.forwardPackageRequest = createAction('@@transfers/FORWARD_PACKAGE_REQUEST');
exports.forwardPackageSuccess = createAction('@@transfers/FORWARD_PACKAGE_SUCCESS', function (resolve) { return function (pkg) { return resolve(pkg); }; });
exports.gatewayTransferCompleted = createAction('@@transfers/GATEWAY_TRANSFER_COMPLETED', function (resolve) { return function (requestId, direction) { return resolve({ requestId: requestId, direction: direction }); }; });
exports.gatewayTransferFailed = createAction('@@transfers/GATEWAY_TRANSFER_FAILED', function (resolve) { return function (requestId, packageId, filePath) { return resolve({ requestId: requestId, packageId: packageId, filePath: filePath }); }; });
exports.gatewayTransferReject = createAction('@@transfers/GATEWAY_TRANSFER_REJECT', function (resolve) { return function (requestId, packageId, filePath) { return resolve({ requestId: requestId, packageId: packageId, filePath: filePath }); }; });
exports.gatewayTransferStarted = createAction('@@transfers/GATEWAY_TRANSFER_STARTED', function (resolve) { return function (requestId, packageId, direction, title) { return resolve({ requestId: requestId, packageId: packageId, direction: direction, title: title }); }; });
exports.getRemoteFilesRequest = createAction('@@transfers/GET_REMOTE_FILES_REQUEST', function (resolve) { return function (sourceId, offset) { return resolve({ sourceId: sourceId, offset: offset }); }; });
exports.getRemoteFilesSuccess = createAction('@@transfers/GET_REMOTE_FILES', function (resolve) { return function (remoteFiles) { return resolve(remoteFiles); }; });
exports.hideAsperaInstall = createAction('@@transfers/HIDE_ASPERA_BANNER');
exports.hideAsperaVersionBanner = createAction('@@transfers/HIDE_ASPERA_VERSION_BANNER');
exports.httpUploadReject = createAction('@@transfers/HTTP_UPLOAD_REJECT', function (resolve) { return function (error, packageId) { return resolve({ error: error, packageId: packageId }); }; });
exports.httpUploadRequest = createAction('@@transfers/HTTP_UPLOAD_REQUEST', function (resolve) { return function (request) { return resolve(request); }; });
exports.httpUploadSuccess = createAction('@@transfers/HTTP_UPLOAD_SUCCESS', function (resolve) { return function (transferState) { return resolve(transferState); }; });
exports.pluginEvent = createAction('@@transfers/PLUGIN_EVENT', function (resolve) { return function (status) { return resolve(status); }; });
exports.remoteTransferReject = createAction('@@transfers/REMOTE_TRANSFER_REJECT');
exports.remoteTransferRequest = createAction('@@transfers/REMOTE_TRANSFER_REQUEST');
exports.remoteTransferSuccess = createAction('@@transfers/REMOTE_TRANSFER_SUCCESS', function (resolve) { return function (pkg) { return resolve(pkg); }; });
/* Remove a file that has been staged for upload. */
exports.removeFile = createAction('@@transfers/REMOVE_FILE', function (resolve) { return function (file) { return resolve(file); }; });
exports.retryHttpUploadRequest = createAction('@@transfers/RETRY_HTTP_UPLOAD_REQUEST', function (resolve) { return function (packageId) { return resolve(packageId); }; });
/* Add one or more files to be uploaded. */
exports.selectFiles = createAction('@@transfers/SELECT_FILES', function (resolve) { return function (files) { return resolve(files); }; });
exports.setConnectVersion = createAction('@@transfers/SET_CONNECT_VERSION', function (resolve) { return function (version) { return resolve(version); }; });
exports.setHttpGatewayStatus = createAction('@@transfers/SET_HTTP_GATEWAY_STATUS', function (resolve) { return function (status) { return resolve(status); }; });
exports.showAsperaInstall = createAction('@@transfers/SHOW_ASPERA_BANNER', function (resolve) { return function (extensionStatus, extensionUrl) { return resolve({ extensionStatus: extensionStatus, extensionUrl: extensionUrl }); }; });
exports.showAsperaVersionBanner = createAction('@@transfers/SHOW_ASPERA_VERSION_BANNER');
exports.storeTransfer = createAction('@@transfers/STORE_TRANSFER', function (resolve) {
    return function (direction, packageTitle, transferTitle, totalSize, transferredBytes, creationDate, modifyDate, packageState, packageId, transferId, isFullPackage, errorCode, errorDesc) {
        return resolve({ direction: direction, packageTitle: packageTitle, transferTitle: transferTitle, totalSize: totalSize, transferredBytes: transferredBytes, creationDate: creationDate, modifyDate: modifyDate, packageState: packageState, transferId: transferId, packageId: packageId, isFullPackage: isFullPackage, errorCode: errorCode, errorDesc: errorDesc });
    };
});
exports.updateTransfer = createAction('@@transfers/UPDATE_TRANSFER', function (resolve) {
    return function (direction, title, totalSize, transferredBytes, creationDate, state, transferId, packageId, isFullPackage, errorCode, errorDesc, retryable) {
        return resolve({ direction: direction, title: title, totalSize: totalSize, transferredBytes: transferredBytes, creationDate: creationDate, state: state, transferId: transferId, packageId: packageId, isFullPackage: isFullPackage, errorCode: errorCode, errorDesc: errorDesc, retryable: retryable });
    };
});
/* Action Creators - end */
/* Transfers' Action Functions - begin */
// Initiates a new download using Aspera Connect
var connectDownload = function (packageId, filePath) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var transferSpec, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.connectDownloadRequest(packageId, filePath));
                    return [4 /*yield*/, TransfersApi.createTransferSpec({
                            direction: api_1.Direction.RECEIVE,
                            packageId: packageId,
                            filePaths: filePath ? [filePath] : []
                        })];
                case 1:
                    transferSpec = _a.sent();
                    eventManager_1.eventManager.emit(pluginActions_1.START_TRANSFER, transferSpec, packageId);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    // Download request failed
                    dispatch(exports.downloadReject(packageId, filePath));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.connectDownload = connectDownload;
/**
 * Initiates a new upload using Aspera Connect
 * @param request
 */
var connectUpload = function (request) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var pkg, transferSpec, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    dispatch(exports.connectUploadRequest());
                    return [4 /*yield*/, PackagesApi.createPackage(request.packageDetails)];
                case 1:
                    pkg = _b.sent();
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Create Package Plugin', "" + pkg.id);
                    return [4 /*yield*/, TransfersApi.createTransferSpec({
                            direction: api_1.Direction.SEND,
                            filePaths: request.files.map(function (f) { return f.path; }),
                            packageId: pkg.id
                        })];
                case 2:
                    transferSpec = _b.sent();
                    // Dispatch event to AsperaConnect plugin
                    eventManager_1.eventManager.emit(pluginActions_1.START_TRANSFER, transferSpec, pkg.id, pkg.title);
                    void actions_3.updateUserInteractions(pkg.recipients)(dispatch);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    dispatch(exports.connectUploadReject());
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Create Package Plugin', 'Failed');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.connectUpload = connectUpload;
var dismissAsperaInstall = function () {
    return function (dispatch) {
        // How long until the aspera banner is prompted to the user again
        var bannerExpiration = moment_1.default().add(config_1.Config.ASPERA_BANNER_TIMEOUT_IN_DAYS, 'days');
        localStorage.setItem(constants_1.ASPERA_BANNER_TIMEOUT_KEY, bannerExpiration.format());
        // Stop from repeatedly polling the Connect client
        dispatch(exports.stopAspera());
        dispatch(exports.hideAsperaInstall());
        new matomo_1.MatomoTracker().trackEvent('User', 'Dismiss Aspera Modal - Use Blast Lite');
    };
};
exports.dismissAsperaInstall = dismissAsperaInstall;
var dismissAsperaVersionBanner = function () {
    return function (dispatch) {
        // How long until the aspera banner is prompted to the user again
        var bannerExpiration = moment_1.default().add(config_1.Config.ASPERA_BANNER_TIMEOUT_IN_DAYS, 'days');
        localStorage.setItem(constants_1.ASPERA_BANNER_TIMEOUT_KEY, bannerExpiration.format());
        dispatch(exports.hideAsperaVersionBanner());
        new matomo_1.MatomoTracker().trackEvent('User', 'Dismiss Aspera Version Banner');
    };
};
exports.dismissAsperaVersionBanner = dismissAsperaVersionBanner;
/**
 * Initiates the forwarding of an existing package
 * @param request
 * @returns {function(Dispatch): Promise<undefined>}
 */
var forwardPackage = function (request) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var pkg, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.forwardPackageRequest());
                    return [4 /*yield*/, PackagesApi.forwardPackage(request)];
                case 1:
                    pkg = _a.sent();
                    dispatch(exports.forwardPackageSuccess(pkg));
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Forward Package', request.packageId + " -> " + pkg.id);
                    // Add recipients to the sender's interactions
                    void actions_3.updateUserInteractions(pkg.recipients)(dispatch);
                    dispatch(connected_react_router_1.push('/dash/packages/upload'));
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    dispatch(exports.forwardPackageReject(error_2, request));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.forwardPackage = forwardPackage;
// Retrieve all transfers that used Aspera Connect
var getAllConnectTransfers = function () {
    return function () {
        eventManager_1.eventManager.emit(pluginActions_1.GET_ALL_TRANSFERS);
    };
};
exports.getAllConnectTransfers = getAllConnectTransfers;
// Retrieve the files of a shared folder (fka remote source)
var getRemoteFiles = function (sourceId, offset, path) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, selectedRemoteSource, remoteFiles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    selectedRemoteSource = state.users.remoteSources.find(function (rs) { return rs.id === String(sourceId); });
                    dispatch(exports.getRemoteFilesRequest(sourceId, offset));
                    remoteFiles = [];
                    if (!(sourceId > 0 && path)) return [3 /*break*/, 4];
                    return [4 /*yield*/, TransfersApi.getRemoteFiles(sourceId, { skip: offset, path: path, count: constants_1.REMOTE_SOURCE_FILES_REQUEST_SIZE, remote_source: selectedRemoteSource })];
                case 1:
                    // Only get list of remote files if the path is specified
                    remoteFiles = _a.sent();
                    if (!(offset && offset > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, actions_2.addToast(actions_2.ToastType.REMOTE_SOURCE_LOAD_MORE, 'Loading more files')(dispatch)];
                case 2:
                    void (_a.sent());
                    new matomo_1.MatomoTracker().trackEvent('User', 'Loading More Remote Source Files', "" + sourceId);
                    return [3 /*break*/, 4];
                case 3:
                    new matomo_1.MatomoTracker().trackEvent('User', 'Open Remote Source', "" + sourceId);
                    _a.label = 4;
                case 4:
                    dispatch(exports.getRemoteFilesSuccess(remoteFiles));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.getRemoteFiles = getRemoteFiles;
/**
 * Initiates a pluginless download
 * @param pkg
 */
var httpDownload = function (pkg) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var checkTransferState;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(exports.updateTransfer(api_1.Direction.RECEIVE, pkg.title, pkg.totalBytes, 0, pkg.creationDate, models_1.PackageTransferState.IN_PROGRESS, undefined, pkg.id, true, undefined, undefined, false));
                    checkTransferState = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var transferState, packageState;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, TransfersApi.downloadHttp(pkg.id)];
                                case 1:
                                    transferState = _a.sent();
                                    if (!(transferState.state === api_1.State.IN_PROGRESS || transferState.state === api_1.State.POST_PROCESSING)) return [3 /*break*/, 2];
                                    dispatch(exports.updateTransfer(api_1.Direction.RECEIVE, pkg.title, transferState.packageTotalSize, transferState.sizeOnDisk, pkg.creationDate, models_1.PackageTransferState.IN_PROGRESS, undefined, pkg.id, true, undefined, undefined, false));
                                    setTimeout(checkTransferState, config_1.Config.PLUGINLESS_DOWNLOAD_POLLING_INTERVAL_IN_MS);
                                    return [3 /*break*/, 6];
                                case 2:
                                    if (!(transferState.state === api_1.State.FAILED)) return [3 /*break*/, 3];
                                    dispatch(exports.downloadReject(pkg.id));
                                    return [3 /*break*/, 6];
                                case 3:
                                    packageState = transferState.state === api_1.State.COMPLETE ?
                                        models_1.PackageTransferState.COMPLETE : models_1.PackageTransferState.FAILED;
                                    dispatch(exports.updateTransfer(api_1.Direction.RECEIVE, pkg.title, transferState.packageTotalSize, transferState.sizeOnDisk, pkg.creationDate, packageState, undefined, pkg.id, true, undefined, undefined, false));
                                    return [4 /*yield*/, TransfersApi.streamDownload(pkg.id)];
                                case 4:
                                    _a.sent();
                                    if (!(packageState === models_1.PackageTransferState.COMPLETE && !pkg.archived)) return [3 /*break*/, 6];
                                    // Mark package as ready
                                    return [4 /*yield*/, PackagesApi.markPackageAsRead(pkg.id)];
                                case 5:
                                    // Mark package as ready
                                    _a.sent();
                                    dispatch(actions_1.markPackageAsArchived(pkg.id));
                                    _a.label = 6;
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); };
                    return [4 /*yield*/, checkTransferState()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.httpDownload = httpDownload;
// Initiates a pluginless download, using Aspera HTTP Gateway
var httpGatewayDownload = function (pkg, file) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var filePath, transferSpec, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filePath = file ? file.path : undefined;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    dispatch(exports.connectDownloadRequest(pkg.id, filePath));
                    return [4 /*yield*/, TransfersApi.createTransferSpec({
                            direction: api_1.Direction.RECEIVE,
                            packageId: pkg.id,
                            filePaths: filePath ? [filePath] : []
                        })];
                case 2:
                    transferSpec = _a.sent();
                    eventManager_1.eventManager.emit(pluginActions_1.START_HTTPGATEWAY_DOWNLOAD, transferSpec, pkg, file);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    // Download request failed
                    dispatch(exports.downloadReject(pkg.id, filePath));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.httpGatewayDownload = httpGatewayDownload;
// Initiates a pluginless upload, using Aspera HTTP Gateway
var httpGatewayUpload = function (request) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var pkg, transferSpec, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.connectUploadRequest());
                    return [4 /*yield*/, PackagesApi.createPackage(request.packageDetails)];
                case 1:
                    pkg = _a.sent();
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Create Package HTTP Gateway', "" + pkg.id);
                    return [4 /*yield*/, TransfersApi.createTransferSpec({
                            direction: api_1.Direction.SEND,
                            filePaths: request.files.map(function (f) { return f.path; }),
                            packageId: pkg.id
                        })];
                case 2:
                    transferSpec = _a.sent();
                    // Dispatch event to AsperaConnect plugin
                    eventManager_1.eventManager.emit(pluginActions_1.START_HTTPGATEWAY_UPLOAD, transferSpec, pkg.id, pkg.title, request.files);
                    // Add recipients to the sender's interactions
                    void actions_3.updateUserInteractions(pkg.recipients)(dispatch);
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    dispatch(exports.connectUploadReject());
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Create Package HTTP Gateway', 'Failed');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.httpGatewayUpload = httpGatewayUpload;
/**
 * Initiates a new pluginless upload
 * @param request
 */
var httpUpload = function (request) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var packageId, pkg, transferState, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    // Dispatch upload started action
                    dispatch(exports.httpUploadRequest(request));
                    return [4 /*yield*/, PackagesApi.createPackage(request.packageDetails)];
                case 1:
                    pkg = _a.sent();
                    packageId = pkg.id;
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Create Package Pluginless', "" + packageId);
                    // Stage files
                    return [4 /*yield*/, TransfersApi.streamUpload(packageId, request.files)];
                case 2:
                    // Stage files
                    _a.sent();
                    return [4 /*yield*/, TransfersApi.uploadHttp(packageId)];
                case 3:
                    transferState = _a.sent();
                    // Dispatch upload succeeded action
                    dispatch(exports.httpUploadSuccess(transferState));
                    // Add recipients to the sender's interactions
                    void actions_3.updateUserInteractions(pkg.recipients)(dispatch);
                    return [3 /*break*/, 5];
                case 4:
                    error_5 = _a.sent();
                    dispatch(exports.httpUploadReject(error_5, packageId));
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Create Package Pluginless', 'Failed');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.httpUpload = httpUpload;
var pushToUploadPage = function () {
    return function (dispatch) {
        dispatch(connected_react_router_1.push('/dash/packages/upload'));
    };
};
exports.pushToUploadPage = pushToUploadPage;
/**
 * Initiates a new upload using Aspera Connect
 * @param request
 */
var remoteTransfer = function (request) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var pkg, transferData, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    dispatch(exports.remoteTransferRequest());
                    return [4 /*yield*/, PackagesApi.createPackage(request.packageDetails)];
                case 1:
                    pkg = _b.sent();
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Create Remote Transfer Package', "" + pkg.id);
                    return [4 /*yield*/, TransfersApi.initiateTransfer({
                            direction: api_1.Direction.SEND,
                            filePaths: request.files.map(function (f) { return f.path; }),
                            packageId: pkg.id,
                            shareId: request.shareId
                        })];
                case 2:
                    transferData = _b.sent();
                    if (transferData) {
                        // Assume success if transferData is returned
                        // Dispatch upload succeeded action
                        dispatch(exports.remoteTransferSuccess(pkg));
                    }
                    // Add recipients to the sender's interactions
                    void actions_3.updateUserInteractions(pkg.recipients)(dispatch);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    dispatch(exports.remoteTransferReject());
                    new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Create Remote Transfer Package', 'Failed');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.remoteTransfer = remoteTransfer;
var resumeConnectTransfer = function (transferId) {
    return function () {
        eventManager_1.eventManager.emit(pluginActions_1.RESUME_TRANSFER, transferId);
    };
};
exports.resumeConnectTransfer = resumeConnectTransfer;
/**
 * Retry a failed pluginless upload
 * @param packageId
 */
var retryHttpUpload = function (packageId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(exports.retryHttpUploadRequest(packageId));
                    return [4 /*yield*/, Promise.resolve(TransfersApi.uploadHttp(packageId))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.retryHttpUpload = retryHttpUpload;
var showAsperaInstallActionCreator = function (extensionStatus, extensionUrl) {
    return function (dispatch) {
        var bannerExpiration = localStorage.getItem(constants_1.ASPERA_BANNER_TIMEOUT_KEY);
        // Show the aspera banner if the timeout has expired
        if (moment_1.default(bannerExpiration || undefined).isSameOrBefore(moment_1.default())) {
            dispatch(exports.showAsperaInstall(extensionStatus, extensionUrl));
        }
        else {
            // Stop from repeatedly polling the Connect client
            dispatch(exports.stopAspera());
        }
    };
};
exports.showAsperaInstallActionCreator = showAsperaInstallActionCreator;
var showAsperaVersionBannerActionCreator = function () {
    return function (dispatch) {
        var bannerExpiration = localStorage.getItem(constants_1.ASPERA_BANNER_TIMEOUT_KEY);
        // Show the aspera banner if the timeout has expired
        if (moment_1.default(bannerExpiration || undefined).isSameOrBefore(moment_1.default())) {
            dispatch(exports.showAsperaVersionBanner());
        }
    };
};
exports.showAsperaVersionBannerActionCreator = showAsperaVersionBannerActionCreator;
// Opens Aspera Connect's directory window
var showDirectory = function (transferId) {
    return function () {
        eventManager_1.eventManager.emit(pluginActions_1.SHOW_DIRECTORY, transferId);
    };
};
exports.showDirectory = showDirectory;
// Opens Aspera Connect's Preferences window
var showPreferences = function () {
    return function () {
        eventManager_1.eventManager.emit(pluginActions_1.SHOW_PREFERENCES);
    };
};
exports.showPreferences = showPreferences;
// Opens Aspera Connect's Transfer Manager window
var showTransferManager = function () {
    return function () {
        eventManager_1.eventManager.emit(pluginActions_1.SHOW_TRANSFER_MANAGER);
    };
};
exports.showTransferManager = showTransferManager;
var startAspera = function () {
    return function (dispatch) {
        dispatch(exports.pluginEvent('INITIALIZING'));
        localStorage.removeItem(constants_1.ASPERA_BANNER_TIMEOUT_KEY);
        eventManager_1.eventManager.emit(pluginActions_1.START);
    };
};
exports.startAspera = startAspera;
var stopAspera = function () {
    return function (dispatch) {
        dispatch(exports.pluginEvent('FAILED'));
        eventManager_1.eventManager.emit(pluginActions_1.STOP);
    };
};
exports.stopAspera = stopAspera;
var stopConnectTransfer = function (transferId) {
    return function () {
        eventManager_1.eventManager.emit(pluginActions_1.STOP_TRANSFER, transferId);
    };
};
exports.stopConnectTransfer = stopConnectTransfer;
/* Transfers' Action Functions - end */
